var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJoystick = function SvgJoystick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.215 1.02c-.779.571-.775 1.403-.282 1.806a3.345 3.345 0 0 1 1.987-.65c.756 0 1.453.249 2.014.67.517-.395.534-1.246-.258-1.826 1.845-.143 2.686 2.017 1.347 3.224A3.361 3.361 0 0 1 10.719 8.8v4.062a.72.72 0 0 1-1.44 0V8.835A3.361 3.361 0 0 1 6.832 4.21C5.545 2.997 6.387.878 8.215 1.02Zm3.625 4.516a1.92 1.92 0 1 1-3.84 0 1.92 1.92 0 0 1 3.84 0Zm-5.5 4.89a.72.72 0 1 0-.535-1.337l-3.273 1.309a.72.72 0 0 0-.452.668v3.928a.72.72 0 0 0 .422.655l7.2 3.273a.72.72 0 0 0 .596 0l7.2-3.273a.72.72 0 0 0 .423-.655v-3.928a.72.72 0 0 0-.453-.668l-3.273-1.31a.72.72 0 1 0-.535 1.338l2.82 1.128v2.976L10 17.476 3.52 14.53v-2.976l2.82-1.128Z",
    clipRule: "evenodd"
  })));
};
export default SvgJoystick;